import { Component, OnInit, OnDestroy, Input, forwardRef } from '@angular/core';
import { Subscription } from 'rxjs';

import * as appConfig from './../../../../../app.config';

import { FormEditorBase } from './../../../../../models/forms/formEditor.base';

import { DragulaService } from 'ng2-dragula';
import { Guid } from './../../../../../shared/utils/guid';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

export const CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => ParametersComponent),
  multi: true
};

@Component({
  selector: 'swb-parameters',
  templateUrl: './parameters.component.html',
  styleUrls: ['./parameters.component.scss'],
  providers: [DragulaService, CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR]
})
export class ParametersComponent extends FormEditorBase implements OnInit, OnDestroy {

  private _onModelChanged: Function;
  private _subscription: Subscription;
  private _guid: string;

  public get value(): Array<any> {
    return [].concat(this.valueCol1, this.valueCol2.map(item => { const newItem = { ...item }; newItem.col = 2; return newItem; }));
  }

  public valueCol1: Array<any> = [];
  public valueCol2: Array<any> = [];

  public langs = appConfig.languages;
  public activeLangIndex = 0;

  public dragulaGroups = [];

  constructor(
    private _dragulaService: DragulaService
  ) {
    super();
    this._guid = Guid.newGuid();

    this.langs.forEach(lang => {
      this.dragulaGroups.push('parameters-' + lang);

      const options: any = {
        moves: (el: any, container: any, handle: any): boolean => {
          return handle.classList.contains('drag-handle');
        }
      };
      this._dragulaService.createGroup('parameters-' + lang, options);
    });

  }

  public ngOnInit(): void {
    this._subscription = this._dragulaService.dropModel().subscribe((dragula: any) => {
      dragula.targetModel.forEach((item: any, order: number) => {
        item['sorter'] = order;
      });
      setTimeout(() => {
        this._onModelChanged(this.value);
      });
    });
  }
  public registerOnChange(fn: Function): void {
    this._onModelChanged = fn;
  }

  public registerOnTouched(fn: Function): void {
    // noop
  }

  public writeValue(value: Array<any>) {
    this.valueCol1 = value.filter((item: any) => {
      return item.col !== 2;
    });
    this.valueCol2 = value.filter((item: any) => {
      return item.col === 2;
    });
  }

  public updateCol1Title(event: InputEvent, lang: string, i: number): void {
    this.valueCol1[i][`title_${lang}`] = (event.target as HTMLInputElement).value;
    this._onModelChanged(this.value);
  }

  public updateCol1Value(event: InputEvent, lang: string, i: number): void {
    this.valueCol1[i][`value_${lang}`] = (event.target as HTMLInputElement).value;
    this._onModelChanged(this.value);
  }

  public updateCol2Title(event: InputEvent, lang: string, i: number): void {
    this.valueCol2[i][`title_${lang}`] = (event.target as HTMLInputElement).value;
    this._onModelChanged(this.value);
  }

  public updateCol2Value(event: InputEvent, lang: string, i: number): void {
    this.valueCol2[i][`value_${lang}`] = (event.target as HTMLInputElement).value;
    this._onModelChanged(this.value);
  }

  public addRowCol1(): void {
    const newRow = {};
    this.langs.forEach(lang => {
      newRow[`title_${lang}`] = '';
      newRow[`value_${lang}`] = '';
      newRow['col'] = 1;
      newRow['sorter'] = 999999;
    });
    this.valueCol1.push(newRow);
    this._onModelChanged(this.value);
  }

  public addRowCol2(): void {
    const newRow = {};
    this.langs.forEach(lang => {
      newRow[`title_${lang}`] = '';
      newRow[`value_${lang}`] = '';
      newRow['col'] = 2;
      newRow['sorter'] = 999999;
    });
    this.valueCol2.push(newRow);
    this._onModelChanged(this.value);
  }

  public removeCol1(i: number) {
    this.valueCol1.splice(i, 1);
    this._onModelChanged(this.value);
  }

  public removeCol2(i: number) {
    this.valueCol2.splice(i, 1);
    this._onModelChanged(this.value);
  }

  public switchTab(langIndex: number): void {
    this.activeLangIndex = langIndex;
  }

  public ngOnDestroy(): void {
    if (this._dragulaService.find('entities') !== undefined) { this._dragulaService.destroy('entities'); }
    if (this._subscription) {
      this._subscription.unsubscribe();
    }
  }

}
